// ------------ Collection page color swatches
/* exported initGridColorSwatches */
function initGridColorSwatches(containerSelector) {
	const gridContainer = document.querySelector(containerSelector);
	if (!gridContainer) {
		return;
	}
	const products = gridContainer.querySelectorAll('.grid__item');
	if (!products) {
		return;
	}
	products.forEach((product) => {
		const relatedColors = product.querySelectorAll('.color_product_boa');
		if (!relatedColors?.length) {
			return;
		}
		const productMainImageElement = product.querySelector('.grid__image-ratio >img');
		const productSecondaryElement = product.querySelector('.grid-product__secondary-image >img');
		const productTitleElement = product.querySelector(
			'.grid-product__title.grid-product__title--body'
		);
		const productLink = product.querySelector('.grid-product__link');
		relatedColors.forEach((colorProduct) => {
          console.log(colorProduct.dataset)
			const {
				productUrl,
				selectedTitle,
				productMainImage,
				productSecondaryImage,
				productPrice,
				productComparePrice,
				productSaveAmount,
				inSale,
				productDiscountT,
			} = colorProduct.dataset;
			colorProduct.addEventListener('click', () => {
				const saveAmountNumber = product.querySelector('#save-amount-number');
				const priceSaleSapn = product.querySelector('.grid-product__price--original');
				const productOriginPriceSpan = product.querySelector('#display-price');
				const priceContainer = productOriginPriceSpan.closest('.grid-product__price');
                const field_set= product.querySelector("fieldset.variant-input-wrap");
				productLink.href = productUrl;
				productMainImageElement.srcset = productMainImage;
				productSecondaryElement.srcset = productSecondaryImage;
				productTitleElement.textContent = selectedTitle;
				colorProduct.classList.add('selected-color');
                    fetch(productUrl)
                     .then(function(response) {
                   return response.text();
                      })
                     .then(function(html) {
                   var parser = new DOMParser();
                    var doc = parser.parseFromString(html, "text/html");
      
                      var all_sizes=doc.querySelector(".variant-input-wrap");
                       var allinner=all_sizes.innerHTML;
                      
                       
                       field_set.innerHTML="";
                       field_set.innerHTML=allinner;
                       
                       
                      });
				if (inSale === 'true') {
					// Price
					productOriginPriceSpan.textContent = productPrice;
					// Original price
					if (priceSaleSapn) {
						priceSaleSapn.textContent = productComparePrice;
					} else {
						priceContainer.appendChild(createOriginalPrice(productComparePrice));
					}
					// Discount
					if (saveAmountNumber) {
						saveAmountNumber.textContent = productSaveAmount;
					} else {
						priceContainer.appendChild(createPriceSaveElement(productDiscountT, productSaveAmount));
					}
					return;
				}
				productOriginPriceSpan.textContent = productPrice;
				priceContainer.textContent = '';
				priceContainer.appendChild(productOriginPriceSpan);
			});
		});
	});
}

function createOriginalPrice(originalPrice) {
	const priceElement = document.createElement('span');
	priceElement.classList.add('grid-product__price--original');
	priceElement.textContent = originalPrice;
	return priceElement;
}

function createPriceSaveElement(productDiscountT, saveAmount) {
	const wrapper = document.createElement('span');
	wrapper.classList.add('grid-product__price--savings');

	const saveAmountElement = document.createElement('span');
	saveAmountElement.id = 'save-amount-number';
	saveAmountElement.textContent = saveAmount;
	wrapper.textContent = productDiscountT + ' ';
	wrapper.appendChild(saveAmountElement);
	return wrapper;
}

